// Systems Analysis, HIDD_SPEPAN1: stored RSP names, including the EYE/PHOTOPIC alias.
export const CODEV_SPECTRAL_RESPONSES = [
  'P_1', 'P_11', 'P_16', 'P_20', 'P_24', 'S_1', 'S_20', 'S_20EX',
  'RCA_I', 'RCA_II', 'RCA_III', 'RCA_IV', 'RCA_V', 'RCA_VI', 'RCA_VII',
  'EARTH', 'EYE', 'PHOTOPIC', 'SCOTOPIC',
  'WRA_2A', 'WRA_2B', 'WRA_2C', 'WRA_2E', 'WRA_3', 'WRA_4', 'WRA_8', 'WRA_9',
  'WRA_12', 'WRA_15', 'WRA_16', 'WRA_21', 'WRA_22', 'WRA_23A', 'WRA_24', 'WRA_25',
  'WRA_26', 'WRA_29',
] as const;
